import { addDays, format, isValid, parseISO } from 'date-fns';

const shiftDate = (value, amount) => format(addDays(parseISO(value), amount), 'yyyy-MM-dd');
export const isScheduleDate = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) &&
  isValid(parseISO(value)) && format(parseISO(value), 'yyyy-MM-dd') === value;

export function schoolToday(now = Date.now()) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(now));
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function normalizeScheduleWindow({ start, days } = {}, today = schoolToday()) {
  return { start: isScheduleDate(start) && start >= today ? start : today, days: Number(days) === 7 ? 7 : 14 };
}
export const scheduleWindowEnd = window => shiftDate(window.start, window.days - 1);
export function shiftScheduleWindow(window, direction, today) {
  return normalizeScheduleWindow({ ...window, start: shiftDate(window.start, direction * window.days) }, today);
}
export function groupScheduleLessons(lessons, window) {
  const end = scheduleWindowEnd(window);
  const groups = [];
  lessons.filter(lesson => isScheduleDate(lesson.date) && lesson.date >= window.start && lesson.date <= end)
    .sort((left, right) => `${left.date} ${left.startTime || ''}`.localeCompare(`${right.date} ${right.startTime || ''}`))
    .forEach(lesson => {
      let group = groups[groups.length - 1];
      if (!group || group.date !== lesson.date) { group = { date: lesson.date, lessons: [] }; groups.push(group); }
      group.lessons.push(lesson);
    });
  return groups;
}
